module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_5.ae3424bc.jpeg";